import React from 'react';
import * as FlexWebChat from '@twilio/flex-webchat-ui';
import 'react-phone-number-input/style.css';

export class PreEngagementFormLogged extends React.Component {
  componentDidMount () {
    const user = this.props.user;
    const { proposalUrl = null } = this.props.data;
    this.onSubmit(user, proposalUrl);
    console.log('PRE ENGAGEMENT FORM LOGGED ')
  }

  onSubmit(user, proposalUrl) {
    const language = window.localStorage.getItem('language') || 'en_US';

    FlexWebChat.Actions.invokeAction('StartEngagement', {
      formData: {
        ...user,
        proposalUrl,
        friendlyName: user.phone,
        language
      }
    });
  }

  render() {
    return (
      <></>
    )
  }
}
